import script from "./MadeProductUpsert.vue?vue&type=script&setup=true&lang=js"
export * from "./MadeProductUpsert.vue?vue&type=script&setup=true&lang=js"

import "./MadeProductUpsert.vue?vue&type=style&index=0&id=8053f1e8&lang=scss"

const __exports__ = script;

export default __exports__